/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegationSummary {
    getFixupPrototypeFunction() { return UserDelegationSummary.fixupPrototype; }

    static newInstance(model: Partial<UserDelegationSummary>): UserDelegationSummary {
        let obj = Object.assign(new UserDelegationSummary(), model);
        UserDelegationSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegationSummary>): UserDelegationSummary {
        if (!model) return null;
        return UserDelegationSummary.newInstance(<UserDelegationSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegationSummary) {
        if (!obj) return;

        models.UserDelegationSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegationSummary): boolean {
        Object.setPrototypeOf(obj, UserDelegationSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tenants) {
            for (let val of this.tenants) {
                models.UserDelegationTenant.fixupPrototype(val);
            }
        }
        if (this.user_groups) {
            for (let val of this.user_groups) {
                models.UserDelegationUserGroup.fixupPrototype(val);
            }
        }
    }

    /**
     * User delegation master account id
     */
    master_account_id: string;

    /**
     * User delegation master account name
     */
    master_account_name: string;

    /**
     * User delegation hierarchy level
     */
    hierarchy_level: string;

    /**
     * Tenants in the delegation
     */
    tenants: Array<models.UserDelegationTenant>;

    /**
     * UserGroups in the delegation
     */
    user_groups: Array<models.UserDelegationUserGroup>;

}
